import { z } from 'zod'

export const interventoSearchSchema = z
  .object({
    fotoModal: z
      .object({
        isOpen: z.coerce.boolean().optional(),
        index: z.coerce.number().optional(),
      })
      .optional(),
    fotoModalOpen: z.coerce.boolean().optional(),
    fotoModalId: z.string().optional(),
  })
  .optional()
